import React, {useEffect, useState} from "react"
import {Form, InputNumber, Modal, Select} from "antd"
import CustomSelect from "../../../components/CustomSelect"
import CustomButton from "../../../components/CustomButton"
import Notifications from "../../../helpers/Notifications"
import api from "./store/api"
import {useTranslation} from "react-i18next"
import {useDispatch, useSelector} from "react-redux";
import {reRegionActions} from "../ReRegion/store/actions";
import {reZoneActions} from "../ReZone/store/actions";
import {setFormErrors} from "../../../helpers/formErrors";

const {Option} = Select

const ReCorrectionFactorChangeForm = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const {visible, setVisible, setRecord, record, changed} = props
    const {t} = useTranslation(['common', 'valid', 'action'])
    const [form] = Form.useForm()
    const regions = useSelector(state => state.reRegionReducer.list)
    const zones = useSelector(state => state.reZoneReducer.list)

    const create = params => {
        action(api.create, params, changed, t('action:created'))
    }
    const update = params => {
        action(api.update, params, changed, t('action:updated'))
    }

    const action = (func, params, sucFunction, sucParams) => {
        setLoading(true)
        func(params)
            .then(res => sucFunction(res, sucParams))
            .catch(err => {
                setFormErrors(err, form)
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if(visible){
            if (regions.length === 0) {
                dispatch(reRegionActions.getList())
            }
            if (zones.length === 0) {
                dispatch(reZoneActions.getList())
            }
        }
    }, [visible])

    useEffect(() => {
        form.resetFields()
        if (record) {
            form.setFieldsValue({
                reRegionBuiltId: record.reRegionBuiltId,
                reZoneBuiltId: record.reZoneBuiltId,
                reRegionId: record.reRegionId,
                reZoneId: record.reZoneId,
                value: record?.value
            })
        }
    }, [record])

    function handleCancel() {
        form.resetFields()
        setRecord(null)
        setVisible(false)
    }

    const save = () => {
        form.validateFields().then(values => {
            const updateValues = {
                id: record?.id,
                reRegionBuiltId: values.reRegionBuiltId,
                reZoneBuiltId: values.reZoneBuiltId,
                reRegionId: values.reRegionId,
                reZoneId: values.reZoneId,
                value: values.value,
                createDate: record?.createDate,
                isDeleted: record?.isDeleted
            }
            const previousValues = {
                id: record?.id,
                reRegionBuiltId: record?.reRegionBuiltId,
                reZoneBuiltId: record?.reZoneBuiltId,
                reRegionId: record?.reRegionId,
                reZoneId: record?.reZoneId,
                value: record?.value,
                createDate: record?.createDate,
                isDeleted: record?.isDeleted
            }
            if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
                Notifications.errorNotice(t('valid:sameData'), null, 20)
            else
                record ? update(updateValues) : create(updateValues)
        })
    }

    return (
        <Modal
            destroyOnHidden
            footer={[
                <CustomButton
                    key="save"
                    loading={loading}
                    type="green"
                    onClick={save}
                >
                    {t('action:save')}
                </CustomButton>
            ]}
            title={record ? t('action:editRecord') : t('action:addRecord')}
            open={visible}
            width={900}
            onCancel={handleCancel}
        >
            <Form
                form={form}
                labelAlign="left"
                labelCol={{span: 6}}
                name="nsi-form"
                wrapperCol={{span: 17, offset: 1}}
            >
                <Form.Item
                    label={t('nri:regionBuilt')}
                    name="reRegionBuiltId"
                    rules={[{required: true}]}
                >
                    <CustomSelect
                        allowClear
                        showSearch
                        filterOption={false}
                        notFoundContent={null}
                        placeholder={`${t('action:choose')} ${t('nri:regionBuilt').toLowerCase()}`}
                        //onSearch={(e) => setSearchRegion(e)}
                    >
                        {regions?.map(item => {
                            return (
                                <Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Option>)
                        })}
                    </CustomSelect>
                </Form.Item>
                <Form.Item
                    label={t('nri:zoneBuilt')}
                    name="reZoneBuiltId"
                    rules={[{required: true}]}
                >
                    <CustomSelect
                        allowClear
                        showSearch
                        filterOption={false}
                        notFoundContent={null}
                        placeholder={`${t('action:choose')} ${t('nri:zoneBuilt').toLowerCase()}`}
                    >
                        {zones?.map(item => {
                            return (
                                <Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.code}
                                </Option>)
                        })}
                    </CustomSelect>
                </Form.Item>
                <Form.Item
                    label={t('common:regionBuild')}
                    name="reRegionId"
                    rules={[{required: true}]}
                >
                    <CustomSelect
                        allowClear
                        showSearch
                        filterOption={false}
                        notFoundContent={null}
                        placeholder={`${t('action:choose')} ${t('common:region').toLowerCase()}`}
                        //onSearch={(e) => setSearchRegion(e)}
                    >
                        {regions?.map(item => {
                            return (
                                <Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Option>)
                        })}
                    </CustomSelect>
                </Form.Item>
                <Form.Item
                    label={t('common:zoneBuild')}
                    name="reZoneId"
                    rules={[{required: true}]}
                >
                    <CustomSelect
                        allowClear
                        showSearch
                        filterOption={false}
                        notFoundContent={null}
                        placeholder={`${t('action:choose')} ${t('common:region').toLowerCase()}`}
                    >
                        {zones?.map(item => {
                            return (
                                <Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.code}
                                </Option>)
                        })}
                    </CustomSelect>
                </Form.Item>
                <Form.Item
                    label={t('common:value')}
                    name="value"
                    rules={[
                        {
                            required: true,
                            type: "number",
                        }
                    ]}
                >
                    <InputNumber
                        min={0}
                        max={2147483647}
                        className='custom-input'
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}
export default ReCorrectionFactorChangeForm
